import styled, { css } from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

import { WithTeam } from '~/core/styleTypes';

import { GameCenterComponentGridAreas } from '../../styles';

export const HEIGHT = 72;

export const centeredFlex = `
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const PlayByPlayContainer = styled.div`
    ${BaseStyle.Mixins.gaps.medium}
    display: flex;
    flex-direction: column;
    grid-area: ${GameCenterComponentGridAreas.playByPlay};
`;

export const PlayByPlayHeader = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['24b']}
    padding-bottom: 8px;
`;

export const AllPlaysContainer = styled.div`
    border-top: 1px solid ${({ theme }) => theme.Surface.border};
`;

export const PlayContainer = styled.div<WithTeam & { $isGoalEvent: boolean }>`
    ${centeredFlex};
    min-height: ${HEIGHT}px;
    padding: 8px 0;

    ${({ theme, $isGoalEvent, $teamAbbrev }) =>
        $isGoalEvent &&
        $teamAbbrev &&
        css`
            background: linear-gradient(0deg, rgba(0, 0, 0, 0.1) 0%, rgba(0, 0, 0, 0.1) 100%),
                ${theme.Team[$teamAbbrev]?.primary || theme.Surface.primary};
        `}

    svg {
        fill: ${({ theme, $isGoalEvent, $teamAbbrev }) =>
            $isGoalEvent && $teamAbbrev ? theme.Team[$teamAbbrev]?.textOnPrimary : theme.Text.secondary};
    }
`;

export const ToggleFiltersContainer = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['14b']}
    color: ${({ theme }) => theme.Utility.cta};
    cursor: pointer;
    display: flex;
    justify-content: center;
`;

export const FilterContainer = styled.div`
    ${BaseStyle.Mixins.gaps.semiMedium}
    display: flex;
    align-items: end;
    justify-content: center;
    flex-direction: column;

    ${BaseStyle.Mixins.screenSizes.medium} {
        flex-direction: row;
    }

    ${BaseStyle.Mixins.screenSizes.extraLarge} {
        ${BaseStyle.Mixins.gaps.large}
    }
`;

export const SelectContainer = styled.div`
    ${BaseStyle.Mixins.gaps.semiMedium}
    display: flex;
    flex-direction: column;
    width: 100%;
`;

export const SelectLabel = styled.label`
    ${BaseStyle.Mixins.fontStyles.ui['12mCaps']}
    color: ${({ theme }) => theme.Text.secondary};
`;

export const NoPlaysMessage = styled.div`
    ${BaseStyle.Mixins.fontStyles.desktop.subtitle1};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: ${({ theme }) => theme.Text.secondary};

    svg {
        fill: ${({ theme }) => theme.Text.disabled};
        font-size: 54px;
        margin-bottom: 24px;
    }
`;
